require('es6-promise').polyfill()

import Vue from 'vue'
import App from './App'
import router from './router'

import Axios from 'axios'

import vuexI18n from 'vuex-i18n'
import i18n from './services/i18n'

import BootstrapVue from 'bootstrap-vue'

import miniToastr from 'mini-toastr'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import './assets/css/oldtimers.css'
import './assets/css/admin.css'
import './assets/css/auth.css'
import './assets/css/content.css'
import './assets/css/home.css'
import './assets/css/parallax.css'

Vue.config.productionTip = false

Vue.use(BootstrapVue, Axios)

import store from './services/store'

Vue.use(vuexI18n.plugin, store)

router.beforeEach((to, from, next) => {
  if ((to.matched.some(record => record.meta.requiresAdmin) && !store.state.auth.admin) ||
    (to.matched.some(record => record.meta.requiresDealer) && !store.state.auth.dealer)
  ) {
    next({
      path: '/login',
      query: {redirect: to.fullPath}
    })
  } else {
    next()
  }
})

Vue.i18n.add('cs', i18n.cs)
Vue.i18n.add('en', i18n.en)

Vue.i18n.set('cs')

miniToastr.init()

/* eslint-disable no-new */
new Vue({
  store,
  router,
  el: '#app',
  template: '<App/>',
  components: { App }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js